export const rgbToRgba = (rgb: string, opacity: number) => {
  return rgb.replace(')', `, ${opacity})`).replace('rgb', 'rgba')
}